import React from 'react'
import { Button, PopUp } from '@ketch-com/deck'
import { Divider, Stack, Typography } from '@mui/material'

import { PieChartDataItem } from '../components/DataPieChart'

type Props = {
  onClose: () => void
  data: PieChartDataItem[]
}

export const AdditionalJurisdictionsModal = ({ onClose, data }: Props) => {
  return (
    <PopUp
      title="Other"
      popUpWidth="550px"
      variant="dialog"
      onClose={onClose}
      popUpActionChildren={
        <Button color="secondary" size="large" onClick={onClose}>
          Close
        </Button>
      }
    >
      <Divider />
      <Stack spacing={1} sx={{ maxHeight: 400, height: 300, overflowY: 'auto', mt: -1, pr: 2 }}>
        {[...data]
          .sort((a, b) => b.originalCount - a.originalCount)
          .map(item => (
            <React.Fragment key={item.name}>
              <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ py: 1 }}>
                <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
                  {item.name}
                </Typography>
                <Typography variant="label">{item.originalCount.toLocaleString()}</Typography>
              </Stack>
              <Divider />
            </React.Fragment>
          ))}
      </Stack>
    </PopUp>
  )
}
